import React from "react"
import BurgerQuicklinksContainer from "../../../BurgerQuickLinksContainer"
import BurgerPrimaryItemLink from "../../../BurgerPrimaryItemLink"
import BurgerPrimaryItemDirectLink from "../../../BurgerPrimaryItemDirectLink"
import {PrimaryNavItem} from "../../../../models/primary-nav"
import {BurgerBodyContainer} from "./components"
import {isPrimaryNavbarLink} from "../../../../utils/primaryNav"

type BurgerPrimaryNavProps = {
    chevronIconAltText: string
    items: PrimaryNavItem[]
    showAsWideView: boolean
    textAlignment: string
    realm: string
    variant: string
    iconsVersionPath: string
    siteUrl: string
}

const testId = "header-burger-menu-primary"

const PrimaryLinks = ({
    chevronIconAltText,
    items,
    textAlignment,
    realm,
    variant,
    siteUrl,
    iconsVersionPath,
}: BurgerPrimaryNavProps) => {
    return (
        <div>
            {items.map(({title, linkColour, fontWeight, path, target, viewType}, index) => {
                const props = {
                    chevronIconAltText,
                    fontWeight,
                    index,
                    siteUrl,
                    linkColour,
                    path,
                    viewType,
                    target,
                    textAlignment,
                    title,
                    realm,
                    variant,
                    iconsVersionPath,
                }
                if (isPrimaryNavbarLink(viewType)) {
                    return <BurgerPrimaryItemDirectLink key={title} itemKey={title} {...props} />
                }
                return <BurgerPrimaryItemLink key={title} itemKey={title} {...props} />
            })}
        </div>
    )
}

export const BurgerPrimaryNav = ({
    items,
    textAlignment,
    chevronIconAltText,
    showAsWideView,
    realm,
    variant,
    siteUrl,
    iconsVersionPath,
}: BurgerPrimaryNavProps) => {
    const props = {
        items,
        textAlignment,
        chevronIconAltText,
        showAsWideView,
        realm,
        variant,
        siteUrl,
        iconsVersionPath,
    }
    return (
        <BurgerBodyContainer data-testid={`${testId}-children`}>
            <PrimaryLinks {...props} data-testid={`${testId}-links`} />
            <BurgerQuicklinksContainer />
        </BurgerBodyContainer>
    )
}
export default BurgerPrimaryNav
